export const RECEIVE_PRODUCTS = "adminProduct/RECEIVE_PRODUCTS";
export const RECEIVE_PRODUCT = "adminProduct/RECEIVE_PRODUCT";

export const SET_PRODUCT_EDITING = "adminProduct/SET_PRODUCT_EDITING";
export const EDIT_PRODUCT_PROP = "adminProduct/EDIT_PRODUCT_PROP";
export const UPDATE_PRODUCT = "adminProduct/UPDATE_PRODUCT";
export const DELETE_PRODUCT = "adminProduct/DELETE_PRODUCT";
export const REORDER_PRODUCTS = "adminProduct/REORDER_PRODUCTS";